import React from 'react';

import PaymentOptions from './payment-option';
import PaymentSummary from './payment-summary';
import MobilePaymentLayout from './mobile-payment-layout/index';

const PaymentComponent = () => {
	return (
		<>
			<section className="hidden md:grid grid-cols-12 h-[calc(100vh_-_600px)] mt-[50px] md:mt-0" key="desktop">
				<PaymentSummary />
				<PaymentOptions />
			</section>

			<section className="md:hidden" key="mobile">
				<MobilePaymentLayout />
			</section>
		</>
	);
};

export default PaymentComponent;
